/* eslint no-unused-vars: 0  */
/* global $ */

/*
Any custom project animations
*/
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { viewportWidth } from '../helpers/dom-tools';

gsap.registerPlugin(ScrollTrigger);

let containerWidth = 0;
let statsWidth = 0;
let triangleAnimation = 0;
let horizontalScrub = 0;

$(window).on('load', () => {
	if (viewportWidth() >= 992) {
		if ($('.horizontal-scroll').length > 0) {
			buildHorizontalScrub();
		}
		if ($('.blue-triangle-background').length > 0) {
			buildTriangleAnimation();
		}
	}
});

function getContainerWidths() {
	// Make sure these exist.
	containerWidth = $('.horizontal-scroll')[0]
		? $('.horizontal-scroll').width()
		: 0;
	statsWidth = $('.stats-container')[0]
		? $('.stats-container')[0].scrollWidth
		: 0;
}

function defineHorizontalScrub() {
	// Make sure gsap targets exist.
	if (!$('.stats-container').length) {
		return;
	}

	return gsap.fromTo(
		'.stats-container',
		{
			x: 0,
		},
		{
			x: -(statsWidth - containerWidth),
			ease: 'none',
			scrollTrigger: {
				trigger: '.stats-container',
				scrub: 0.5,
				start: 'bottom 85%',
				end: 'top 15%',
				invalidateOnRefresh: true,
			},
		}
	);
}

function buildHorizontalScrub() {
	getContainerWidths();
	if (horizontalScrub) horizontalScrub.kill();
	horizontalScrub = defineHorizontalScrub();
}

function defineTriangleAnimation() {
	const triangleContainerWidth = $(
		'.blue-triangle-background .container'
	).width();

	// Make sure gsap targets exist.
	if (!$('.blue-triangle-background .triangle-element').length) {
		return;
	}

	return gsap.fromTo(
		'.blue-triangle-background .triangle-element',
		{
			x: 0,
		},
		{
			x: -(
				triangleContainerWidth +
				(window.innerWidth - triangleContainerWidth) / 2 +
				115
			),
			ease: 'none',
			scrollTrigger: {
				trigger: '.topper__content',
				scrub: 0.5,
				start: 'top top',
				endTrigger: '.module.services',
				end: 'top center',
				invalidateOnRefresh: true,
			},
		}
	);
}

function buildTriangleAnimation() {
	if (triangleAnimation) triangleAnimation.kill();
	triangleAnimation = defineTriangleAnimation();
}

$(window).on('resize', (e) => {
	if (viewportWidth() <= 991) {
		if (horizontalScrub) horizontalScrub.kill();
		if (triangleAnimation) triangleAnimation.kill();
	}
	if (viewportWidth() >= 992) {
		buildTriangleAnimation();
		buildHorizontalScrub();
		ScrollTrigger.refresh();
	}
});

// Outline text fill section hover animation
let $activeBlockText = null;
$('.cta-block').hover(function () {
	$activeBlockText = $(this).find('.outline-text');
});
$('.cta-block .thick-underline-link').mouseover(function () {
	gsap.to($activeBlockText, {
		duration: 0.25,
		textFillColor: 'white',
		ease: 'power1.inOut',
	});
});
$('.cta-block .thick-underline-link').mouseleave(function () {
	gsap.to($activeBlockText, {
		duration: 0.25,
		textFillColor: 'transparent',
		ease: 'power1.inOut',
	});
});
